import { createRouter, createWebHistory } from 'vue-router';
import { authService } from '@/services/api/authService';

// Lazy loading des vues
const LoginView = () => import('@/views/LoginView.vue');
const RegisterView = () => import('@/views/RegisterView.vue');
const SharedSimulationView = () => import('@/views/SharedSimulationView.vue');
const DemoView = () => import('@/views/DemoView.vue');
const AdminView = () => import('@/views/AdminView.vue');

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { requiresGuest: true }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/TimelineEditor.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // Demo (accès public)
  {
    path: '/demo',
    name: 'Demo',
    component: DemoView,
    meta: { public: true }
  },
  // Routes de partage (accès public)
  {
    path: '/shared/simulation/:token',
    name: 'SharedSimulation',
    component: SharedSimulationView,
    meta: { public: true }
  },
  {
    path: '/shared/catalog/:token',
    name: 'SharedCatalog',
    redirect: () => {
      // Redirige vers l'accueil pour les catalogues (pas de vue dédiée)
      return { name: 'Home' };
    }
  },
  // Redirection par défaut
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = authService.isAuthenticated();

  // Routes publiques (partage) - pas de vérification
  if (to.meta.public) {
    next();
    return;
  }

  // Route nécessitant authentification
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' });
    return;
  }

  // Route réservée aux admins
  if (to.meta.requiresAdmin) {
    const storedUser = authService.getStoredUser();
    if (!storedUser || storedUser.role !== 'ADMIN') {
      next({ name: 'Home' });
      return;
    }
  }

  // Route réservée aux visiteurs (login/register)
  if (to.meta.requiresGuest && isAuthenticated) {
    next({ name: 'Home' });
    return;
  }

  next();
});

export default router;
